import { ILanguage } from '../languages/language';

export class WebsiteStaticTextsTranslation {
    constructor(languages: ILanguage[]) {

    }
}
